export enum QrBatchType {
    LINK = 'link',
    PLAIN_TEXT = 'text',
    SERIAL_NUMBER = 'serial_number',
    RANDOM_CODE = 'random_code',
}

export type QrTableRow = [string, string]
export type QrTable = QrTableRow[]

export enum QrFormType {
    CIRCLE = 'circle',
    SQUARE = 'square'
}
